import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { useStateMachine } from "little-state-machine";
import { useParams } from "react-router-dom";

import CustomField from "pages/shipper/ShipmentQuotes/components/customField/customField";
import QuotationFromToDetail from "pages/provider/QuotationDetail/QuotationFromToDetail";
import { useGetQuoteRequestDetails } from "api/queries/quotes/useGetQuoteRequestDetails";
import QuoteMultiDropBanner from "pages/common/QuotesDetail/components/QuoteMultiDropBanner/QuoteMultiDropBanner";
import Comments from "pages/provider/ShipmentQuotesV2/components/Comments";
import QuotationList from "./QuotationList";
import { IShipmentData } from "./QuotationType";

interface IQuotationViewProps {
  isQuickRequest: boolean;
  shipmentData: IShipmentData;
  shipmentBasicError: any;
}

const QuotationView = function (props: IQuotationViewProps) {
  const [showTab, setShowTab] = useState("quotes");

  const id: any = useParams()?.id?.toUpperCase();
  const { shipmentData, shipmentBasicError, isQuickRequest } = props;
  const { state }: any = useStateMachine({ updateShipment, updateRequest });
  const methods = useForm();

  const {
    data,
    isInitialLoading: loadingData,
    refetch: refetchQuoteDetails,
  } = useGetQuoteRequestDetails({
    shipmentId: id,
    options: {
      enabled: !!id,
      refetchOnMount: false,
    },
  });

  const { custom_longfield_01 } = data?.organization || {};

  useEffect(() => {
    refetchQuoteDetails();
  }, [state.shipmentId, state.isupdateRequest]); // eslint-disable-line react-hooks/exhaustive-deps

  function updateShipment(state: any, payload: any) {
    return {
      ...state,
      shipment: payload.shipment,
    };
  }

  function updateRequest(state: any, payload: { isupdateRequest: boolean }) {
    return {
      ...state,
      isupdateRequest: payload.isupdateRequest,
    };
  }

  return (
    <FormProvider {...methods}>
      <div>
        <QuoteMultiDropBanner isQuickRequest={isQuickRequest} />
        <QuotationList
          key={id}
          id={id}
          providers={null}
          quoteDetailData={data}
          showTab={showTab}
          setShowTab={setShowTab}
          shipmentData={shipmentData}
          shipmentBasicError={shipmentBasicError}
        />
        <Row className="mx-0 gap-xl quotation-view-row">
          {showTab === "detail" && (
            <Col md={12} lg={12} className="p-0">
              <QuotationFromToDetail data={data} />
            </Col>
          )}
          <Col md={6} lg={6} className="p-0">
            <div className="v1-card-wrapper">
              <Comments />
            </div>
          </Col>
          {custom_longfield_01 && (
            <Col md={6} lg={4} className="p-0">
              <CustomField status={200} shipmentId={id} quotesData={data} loadingData={loadingData} userType="provider" />
            </Col>
          )}
        </Row>
      </div>
    </FormProvider>
  );
};

export default QuotationView;
